export default {
  '/styles/animation/2d': {
    timings: [
      {
        portfolio_url: 'MotionClub',
        start: 1,
        end: 8
      },
      {
        portfolio_url: 'GaryMayes',
        start: 9,
        end: 17
      },
      {
        portfolio_url: 'LukeScriven',
        start: 18,
        end: 22
      },
      {
        portfolio_url: 'GaryMayes',
        start: 23,
        end: 27
      },
      {
        portfolio_url: 'Lorica',
        start: 28,
        end: 33
      },
      {
        portfolio_url: 'MotionClub',
        start: 34,
        end: 40
      },
      {
        portfolio_url: 'Tapocketa',
        start: 41,
        end: 44
      },
      {
        portfolio_url: 'Lorica',
        start: 45,
        end: 50
      },
      {
        portfolio_url: 'LiamBrazier',
        start: 51,
        end: 56
      },
      {
        portfolio_url: 'Lorica',
        start: 57,
        end: 60
      },
      {
        portfolio_url: 'TimBradford',
        start: 61,
        end: 64
      },
      {
        portfolio_url: 'MarvinTe',
        start: 65,
        end: 68
      },
      {
        portfolio_url: 'Lorica',
        start: 69,
        end: 73
      },
      {
        portfolio_url: 'GaryMayes',
        start: 74,
        end: 83
      },
      {
        portfolio_url: 'MatthewRobson',
        start: 84,
        end: 89
      },
      {
        portfolio_url: 'PeterNizic',
        start: 90,
        end: 96
      }
    ]
  },
  '/styles/animation/3d': {
    timings: [
      {
        portfolio_url: 'CUBE',
        start: 1,
        end: 5
      },
      {
        portfolio_url: 'MauriceBaltissen',
        start: 6,
        end: 9
      },
      {
        portfolio_url: 'Lorica',
        start: 10,
        end: 15
      },
      {
        portfolio_url: 'CUBE',
        start: 16,
        end: 21
      },
      {
        portfolio_url: 'StephenTurcott',
        start: 22,
        end: 27
      },
      {
        portfolio_url: 'CUBE',
        start: 28,
        end: 32
      },
      {
        portfolio_url: 'Lorica',
        start: 33,
        end: 36
      },
      {
        portfolio_url: 'MauriceBaltissen',
        start: 37,
        end: 42
      },
      {
        portfolio_url: 'PeterNizic',
        start: 43,
        end: 45
      }
    ]
  },
  '/styles/animation/explainers': {
    timings: [
      {
        portfolio_url: 'MarvinTe',
        start: 1,
        end: 7
      },
      {
        portfolio_url: 'Echopic',
        start: 8,
        end: 15
      },
      {
        portfolio_url: 'GaryMayes',
        start: 16,
        end: 19
      },
      {
        portfolio_url: 'Echopic',
        start: 20,
        end: 26
      },
      {
        portfolio_url: 'MarvinTe',
        start: 27,
        end: 39
      },
      {
        portfolio_url: 'MatthewRobson',
        start: 40,
        end: 51
      },
      {
        portfolio_url: 'Echopic',
        start: 52,
        end: 59
      },
      {
        portfolio_url: 'MatthewRobson',
        start: 60,
        end: 65
      }
    ]
  },
  '/styles/animation/character-design': {
    timings: [
      {
        portfolio_url: 'CUBE',
        start: 1,
        end: 6
      },
      {
        portfolio_url: 'Lorica',
        start: 7,
        end: 13
      },
      {
        portfolio_url: 'MotionClub',
        start: 14,
        end: 16
      },
      {
        portfolio_url: 'MatthewRobson',
        start: 17,
        end: 22
      },
      {
        portfolio_url: 'CUBE',
        start: 23,
        end: 29
      },
      {
        portfolio_url: 'Lorica',
        start: 30,
        end: 38
      },
      {
        portfolio_url: 'SeasonofVictory',
        start: 39,
        end: 43
      },
      {
        portfolio_url: 'Tapocketa',
        start: 44,
        end: 52
      },
      {
        portfolio_url: 'MauriceBaltissen',
        start: 53,
        end: 61
      },
    ]
  },
  '/styles/animation/children': {
    timings: [
      {
        portfolio_url: 'CUBE',
        start: 1,
        end: 14
      },
      {
        portfolio_url: 'Lorica',
        start: 15,
        end: 22
      },
      {
        portfolio_url: 'CUBE',
        start: 23,
        end: 31
      },
      {
        portfolio_url: 'Tapocketa',
        start: 32,
        end: 37
      },
      {
        portfolio_url: 'Lorica',
        start: 38,
        end: 43
      },
      {
        portfolio_url: 'CUBE',
        start: 44,
        end: 54
      },
      {
        portfolio_url: 'Tapocketa',
        start: 55,
        end: 58
      },
      {
        portfolio_url: 'MatthewRobson',
        start: 59,
        end: 68
      },
      {
        portfolio_url: 'CUBE',
        start: 69,
        end: 84
      },
      {
        portfolio_url: 'MatthewRobson',
        start: 85,
        end: 90
      }
    ]
  },
  '/styles/animation/motion-graphics': {
    timings: [
      {
        portfolio_url: 'PeterNizic',
        start: 1,
        end: 11
      },
      {
        portfolio_url: 'StephenTurcott',
        start: 12,
        end: 16
      },
      {
        portfolio_url: 'GaryMayes',
        start: 17,
        end: 23
      },
      {
        portfolio_url: 'PeterNizic',
        start: 24,
        end: 31
      },
      {
        portfolio_url: 'StephenTurcott',
        start: 32,
        end: 39
      },
      {
        portfolio_url: 'StephenTurcott',
        start: 44,
        end: 45
      },
      {
        portfolio_url: 'GaryMayes',
        start: 46,
        end: 52
      }

    ]
  }
}

